export default __webpack_public_path__ + "static/media/Entrance.6923d620.mp4";